import { useEffect, useRef } from "react";
import AudioManager from "../utils/AudioManager";
import { useSoundsStore } from "../store/useSoundsStore";

export function useAudioManager() {
  // const bgSoundRef = useRef(null); // Current background sound
  // const { musicVolume, isMusicMuted, sfxVolume, isSfxMuted } = useSoundsStore();

  const { musicVolume, isMusicMuted, sfxVolume, isSfxMuted } = useSoundsStore()

  // 🔁 Call this when screen changes
  // const playBackgroundMusic = async (soundUris = []) => {
  //   if (!soundUris.length || isMusicMuted) return;

  //   // Pick a random song from array
  //   const randomUri = soundUris[Math.floor(Math.random() * soundUris.length)];

  //   // Unload current track if exists
  //   if (bgSoundRef.current) {
  //     await bgSoundRef.current.unloadAsync();
  //     bgSoundRef.current = null;
  //   }

  //   // Load & play new track
  //   const { sound } = await Audio.Sound.createAsync(
  //     { uri: randomUri },
  //     {
  //       volume: musicVolume,
  //       isLooping: true,
  //       shouldPlay: true,
  //     }
  //   );

  //   bgSoundRef.current = sound;
  // };



  const playBackgroundMusic = (soundUris = []) => {
    if (isMusicMuted || !soundUris.length) return;
    AudioManager.playPlaylist(soundUris, musicVolume);
  };


  // const playBackgroundMusic = (soundUris = []) => {
  //   if (isMusicMuted || !soundUris.length) return;
  //   // pick one, then hand off to AudioManager
  //   const url = soundUris[Math.floor(Math.random() * soundUris.length)];
  //   AudioManager.playMusic(url, musicVolume);
  // };

  // const stopBackgroundMusic = async () => {
  //   if (bgSoundRef.current) {
  //     await bgSoundRef.current.stopAsync();
  //   }
  // };

  const stopBackgroundMusic = () => {
    AudioManager.stopMusic();
  };

  // const playSFX = async (sfxUri) => {
  //   if (isSfxMuted || !sfxUri) return;

  //   const { sound } = await Audio.Sound.createAsync(
  //     { uri: sfxUri },
  //     { volume: sfxVolume }
  //   );
  //   await sound.playAsync();

  //   // Auto-unload after play
  //   sound.setOnPlaybackStatusUpdate((status) => {
  //     if (status.didJustFinish) {
  //       sound.unloadAsync();
  //     }
  //   });
  // };

  // ⏫ Auto-sync background volume when it changes

  const playSFX = (key) => {
    if (isSfxMuted) return;
    AudioManager.playSFX(key, sfxVolume);


  };

  useEffect(() => {
    // if (bgSoundRef.current) {
    //   bgSoundRef.current.setStatusAsync({ volume: musicVolume });
    // }

    AudioManager.setMusicVolume(musicVolume);
  }, [musicVolume]);

  useEffect(() => {
    // if any future reactive adjustments needed
    console.log("🔊 Updated SFX Volume:", sfxVolume);
  }, [sfxVolume]);

  return {
    playBackgroundMusic,
    stopBackgroundMusic,
    playSFX,
  };
}
